export { default, setup } from './sentry'
